import styled from 'styled-components'

export const SeparatorStyled = styled.div`
  flex-grow: 1;
`
